export default `
<a ng-if="$ctrl.isSelected" class="unauthenticated-nav-bar__routed-link unauthenticated-nav-bar__link" href={{$ctrl.route}} aria-current="true">
  <span class="unauthenticated-nav-bar__link-text unauthenticated-nav-bar__link-text--selected">{{$ctrl.name}}</span>
</a>
<a ng-if="!$ctrl.isSelected" class="unauthenticated-nav-bar__routed-link unauthenticated-nav-bar__link" href={{$ctrl.route}}>
  <span class="unauthenticated-nav-bar__link-text">{{$ctrl.name}}</span>
</a>
`;
